import u from 'umbrellajs'

export default function initB64() {
  document.querySelectorAll('[data-b64]').forEach(function(element){
    element.innerHTML = atob(element.getAttribute('data-b64'))
  })
  document.querySelectorAll('[data-click-b64]').forEach(function(element){
    element.addEventListener('click', function(){
      element.innerHTML = atob(element.getAttribute('data-click-b64'))
    })
  })
  document.querySelectorAll('[data-mobile-click-b64]').forEach(function(element){
    element.addEventListener('click', function(e){
      e.preventDefault;
      e.stopPropagation;
      var telephone = atob(element.getAttribute('data-mobile-click-b64'));
      element.innerHTML = "<a href='tel:" + telephone + "'>" + telephone + "</a>";
    })
  })
  u('[data-click-to-call]').handle('click', event => {
    const phone = atob(u(event.target).data('click-to-call')) || false
    if(!phone){ throw new Error('Invalid phone number recieved', phone) }
    window.location.href = 'tel://' + phone.replace(/\s+/g, '');
  })
}
